<div class="SessionInfoPanel apptBookerComponent">
  <div *ngIf="aptState === 0" class="session-search-container">
    <dx-text-box
      mode="search"
      [height]="34"
      width="100%"
      placeholder="Search for session by name"
      (onInput)="onSessionSearchInput($event)"
      [disabled]="!sessions?.length"
    >
    </dx-text-box>
  </div>
  <dx-tile-view
    *ngIf="!(sessionSearchActive && !_sessionTiles?.length)"
    apptBookerComponent
    ng-star-inserted
    MakeSalePanel
    #sessionPanel
    id="sessionPanel"
    [items]="_sessionTiles"
    direction="vertical"
    [baseItemHeight]="100"
    [baseItemWidth]="100"
    [elementAttr]="{ class: 'session-panel' }"
    [itemMargin]="10"
    itemTemplate="list-item"
    [height]="220"
    width="100%"
    showScrollbar="always"
    noDataText=""
    (onContentReady)="onContentReady($event)"
  >
    <div *dxTemplate="let data of 'list-item'; let index = index">
      <div
        class="session"
        (click)="itemClicked(data)"
        [class.session-category]="data.IsCategory"
        [class.selected-session]="!data.IsCategory && data.Selected"
        [class.selected-session-category]="data.IsCategory && data.Selected"
      >
        <div class="sessionName">{{ data.Description }}</div>
        <div *ngIf="!data.IsCategory" class="sessionPrice">
          {{ data?.RetailPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}
        </div>
      </div>
    </div>
  </dx-tile-view>
  <div *ngIf="sessionSearchActive && !_sessionTiles?.length" class="no-results-message">No results found</div>
</div>
